import React, {createContext, PropsWithChildren, useContext, useMemo} from "react";
import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useProjectId} from "../ProjectName";
import {ProjectSupplierCategory} from "../../../../api/SupplierCategories";
import {useAlternative} from "../../quote/alternative/Alternative";
import {ChangePreviewContext} from "../ShopDrawingChangePreview";

const SupplierContext = createContext({
    list: [] as ProjectSupplierCategory[] | null,
    reload: () => {},
});

export function useSupplierCategories() {
    return useContext(SupplierContext);
}

export function SupplierProvider(props: PropsWithChildren<{}>) {
    const project = useProjectId();
    const alt = useAlternative();
    const previewChangeset = useContext(ChangePreviewContext);
    const previewId = previewChangeset.enabled ? previewChangeset.sessionId : undefined;

    const rs = useAsync2((input) => api.supplierCategories.listForProject(input), {
        project,
        alternative: alt,
        previewChangeset: previewId,
    }, [project, alt, previewId]);

    const result = rs.result;
    const reload = rs.reload;

    const value = useMemo(() => {
        return {
            list: result,
            reload: reload,
        }
    }, [result, reload]);

    return <SupplierContext.Provider value={value}>
        {props.children}
    </SupplierContext.Provider>;
}
